import React, { ChangeEvent, useState } from "react";
import { DeleteDataTSXProps } from "../../../../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { DELETE_JDL_END_POINT } from "../../../../../config/config";
import { api, getToken } from "../../../../../services/apis/auth-api/apiUrl";

const DeleteJdl : React.FC<DeleteDataTSXProps> = ({id, name})=> {

    const [confirmed, setConfirmed] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [deleted, setDelete] = useState<boolean | null>(null);

    const handleCheckboxChange = (e : ChangeEvent<HTMLInputElement>) => {
        setConfirmed(e.target.checked);
    };

    function deleteJdl(){
        if(!confirmed) return false;
        setLoading(true);

        setTimeout(async()=>{
            try{
                await api.delete(DELETE_JDL_END_POINT+id, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                });
                setDelete(true);
                setLoading(false);
            }catch(e){
                setDelete(false);
                setLoading(false)
            }
        },500)
    }
      
    if(loading){
        return (
            <div className="flex justify-center items-center my-8">
                <FontAwesomeIcon icon={faSpinner} className="text-4xl text-gray-600 animate-spin" />
            </div>
        )
    }

    if(deleted === true){
        return(
            <div className="flex justify-center items-center my-8 text-xl">
                <FontAwesomeIcon icon={faCheckCircle} className="text-green-600" />
                JDL Deleted
            </div>
        )
    }

    if(deleted === false){
        return(
            <div className="flex justify-center items-center my-8 text-xl">
                <FontAwesomeIcon icon={faCheckCircle} className="text-red-500" />
                An error occured!
            </div>
        )
    }
      
    return (
        <div className="py-2 px-4">
            <div className="mb-4">
                <FontAwesomeIcon className="text-red-500" icon={faTimesCircle} />&nbsp;
                Delete {name !== '' ? name : 'all selected JDL' } ?
            </div>
            <div className="text-gray-600 text-xl">
                This Process cannot be undone.
            </div>
            <div className="my-3 flex gap-2">
                <input onChange={handleCheckboxChange} type="checkbox" />
                <p>Confirm deletion.</p>
            </div>
            <div>
                <button type="button" onClick={deleteJdl} className={confirmed ? "button button-danger" : "button button-disabled hover:cursor-not-allowed"}>
                    Delete
                </button>
            </div>
        </div>
    )
}

export default DeleteJdl;